/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ConnectRow_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SocialLinkRow_viewer">;
    readonly " $refType": "ConnectRow_viewer";
};
export type ConnectRow_viewer$data = ConnectRow_viewer;
export type ConnectRow_viewer$key = {
    readonly " $data"?: ConnectRow_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ConnectRow_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ConnectRow_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SocialLinkRow_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '75f44c0cdb553d5d4a5a8a722327a53a';
export default node;
